export { default as Tooltip } from './component';
export * from './context';
